import { useState, useEffect } from 'react'

export function OfflineIndicator() {
  const [isOffline, setIsOffline] = useState(!navigator.onLine)
  const [showBanner, setShowBanner] = useState(false)
  const [expanded, setExpanded] = useState(false)

  useEffect(() => {
    const handleOnline = () => {
      setIsOffline(false)
      setExpanded(false)
      // Show "back online" briefly
      setShowBanner(true)
      setTimeout(() => setShowBanner(false), 3000)
    }

    const handleOffline = () => {
      setIsOffline(true)
      setShowBanner(true)
    }

    window.addEventListener('online', handleOnline)
    window.addEventListener('offline', handleOffline)

    // Show banner initially if offline
    if (!navigator.onLine) {
      setShowBanner(true)
    }

    return () => {
      window.removeEventListener('online', handleOnline)
      window.removeEventListener('offline', handleOffline)
    }
  }, [])

  if (!showBanner) return null

  return (
    <div
      className="offline-banner"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        backgroundColor: isOffline ? 'var(--color-bg-light)' : 'var(--color-success)',
        color: isOffline ? 'var(--color-text)' : '#fff',
        textAlign: 'center',
        fontSize: '0.875rem',
        fontWeight: 500,
        zIndex: 1000,
        animation: 'slideDown 0.3s ease-out',
        borderBottom: isOffline ? '1px solid var(--color-border)' : 'none'
      }}
    >
      {isOffline ? (
        <div style={{ padding: '0.75rem 1rem' }}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '0.5rem',
              cursor: 'pointer'
            }}
            onClick={() => setExpanded(!expanded)}
          >
            <span>📡</span>
            <span>You're offline</span>
            <span style={{
              fontSize: '0.75rem',
              color: 'var(--color-text-muted)',
              marginLeft: '0.25rem'
            }}>
              {expanded ? '▲' : '▼'}
            </span>
          </div>
          {expanded && (
            <div style={{
              marginTop: '0.75rem',
              paddingTop: '0.75rem',
              borderTop: '1px solid var(--color-border)',
              fontSize: '0.8125rem',
              color: 'var(--color-text-muted)',
              textAlign: 'left',
              maxWidth: '300px',
              margin: '0.75rem auto 0'
            }}>
              <p style={{ marginBottom: '0.5rem' }}>
                <strong style={{ color: 'var(--color-success)' }}>Still works:</strong>
              </p>
              <ul style={{ marginLeft: '1rem', marginBottom: '0.5rem' }}>
                <li>View past sessions</li>
                <li>Access crisis resources</li>
                <li>Read saved insights</li>
              </ul>
              <p style={{ marginBottom: '0.5rem' }}>
                <strong style={{ color: 'var(--color-warning)' }}>Needs connection:</strong>
              </p>
              <ul style={{ marginLeft: '1rem' }}>
                <li>Create new sessions</li>
                <li>Voice transcription</li>
              </ul>
            </div>
          )}
        </div>
      ) : (
        <div style={{ padding: '0.5rem 1rem' }}>
          <span style={{ marginRight: '0.5rem' }}>✓</span>
          Back online! Your data will sync.
        </div>
      )}
    </div>
  )
}
